'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessage = exports.getMessage = exports.getMessagesWithStatus = exports.getMessages = undefined;

var _internalMessage = require('tg-core-api/lib/internal-message');

var _internalMessage2 = _interopRequireDefault(_internalMessage);

var _internalMessageFt = require('tg-core-api/lib/internal-message-ft');

var _internalMessageFt2 = _interopRequireDefault(_internalMessageFt);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getProvider = function getProvider(provider) {
  if (provider === 'fasttrack') return _internalMessageFt2.default;
  return _internalMessage2.default;
};

var getMessages = exports.getMessages = function getMessages(playerSessionID) {
  var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (0, _action.makeApiCallAction)('GET_MESSAGES', getProvider(provider).getMessages(playerSessionID));
};
var getMessagesWithStatus = exports.getMessagesWithStatus = function getMessagesWithStatus(playerSessionID, status) {
  var provider = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _action.makeApiCallAction)('GET_' + status.toUpperCase() + '_MESSAGES', getProvider(provider).getMessagesWithStatus(playerSessionID, status));
};
var getMessage = exports.getMessage = function getMessage(playerSessionID, messageID) {
  var provider = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _action.makeApiCallAction)('GET_MESSAGE', getProvider(provider).getMessage(playerSessionID, messageID));
};
var markMessage = exports.markMessage = function markMessage(playerSessionID, data) {
  var provider = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _action.makeApiCallAction)('MARK_MESSAGE_AS_' + data.Status.toUpperCase(), getProvider(provider).markMessage(playerSessionID, data));
};

exports.default = {
  getMessages: getMessages,
  getMessagesWithStatus: getMessagesWithStatus,
  getMessage: getMessage,
  markMessage: markMessage
};